import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { CartItem } from 'src/app/modals/cart-item';
import { CartService } from '../services/cart.service';
import { SidenavMenu } from '../sidebar/sidebar-menu.model';
import { MatSidenav } from '@angular/material';
import { FormControl } from '@angular/forms';
import { ProductService } from '../services/product.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedMethods } from '../services/sharedMethods-service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-header-three',
  templateUrl: './header-three.component.html',
  styleUrls: ['./header-three.component.scss']
})
export class HeaderThreeComponent implements OnInit {

  public sidenavMenuItems:Array<any>;

  @Input() inputSideNav: MatSidenav;
  @Input() inputCartSideNav: MatSidenav;

  public currencies = ['USD', 'EUR'];
  public currency:any;
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;

  // products: Product[];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];

  navItems: SidenavMenu[] = [
    {
      displayName: 'Home',
      iconName: 'recent_actors',
      children: [
        {
          displayName: 'Home-1',
          iconName: 'group',
          route: '/home/one'
        },
        {
          displayName: 'Home-2',
          iconName: 'speaker_notes',
          route: '/home/two',
        },
        {
          displayName: 'Home-3',
          iconName: 'feedback',
          route: '/home/three'
        }
      ]
    },
    {
      displayName: 'Products',
          iconName: 'feedback',
          route: '/home/products/all'
    },
    {
      displayName: 'Shop',
      iconName: 'movie_filter',
      children: [
        {
          displayName: 'Computers',
          iconName: 'group',
          children: [
            {
              displayName: 'Laptops',
              iconName: 'person',
              route: '/home/products/Laptops',
            },
            {
              displayName: 'Cables',
              iconName: 'person',
              route: 'stephen-fluin',
               },
            {
              displayName: 'Monitors',
              iconName: 'person',
              route: 'mike-brocchi',
           },
           {
            displayName: 'Tablets',
            iconName: 'person',
            route: 'mike-brocchi',
         },
         {
          displayName: 'Headsets',
          iconName: 'person',
          route: 'mike-brocchi',
       }
          ]
        },
        {
          displayName: 'Tv & Audio',
          iconName: 'speaker_notes',
          children: [
            {
              displayName: 'Tv',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Audio',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Video',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Dvd',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        },
        {
          displayName: 'Phones',
          iconName: 'feedback',
          children: [
            {
              displayName: 'Mobile phones',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Power Bank',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Memory Cards',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Accesories',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        },
        {
          displayName: 'Electronics',
          iconName: 'feedback',
          children: [
            {
              displayName: 'Washing Machines',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Water heater',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Cookers',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Cold stores',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        }
      ]
    },
    {
      displayName: 'Blog',
      iconName: 'report_problem',
      children: [
        {
          displayName: 'Blog List',
          iconName: 'group',
          route: '/blog/blog-list'
        },
        {
          displayName: 'Blog Columns',
          iconName: 'speaker_notes',
          route: '/blog/blog-column',
        },
        {
          displayName: 'Blog Details',
          iconName: 'feedback',
          route: '/blog/blog-details'
        }
      ]
    },
    {
      displayName: 'Pages',
      iconName: 'report_problem',
      children: [
        {
          displayName: 'About Us',
          iconName: 'group',
          route: '/pages/about'
        },
        {
          displayName: 'FAQ',
          iconName: 'speaker_notes',
          route: '/pages/faq',
        },
        {
          displayName: 'Contact',
          iconName: 'feedback',
          route: '/pages/contact'
        },
        {
          displayName: 'Wishlist',
          iconName: 'group',
          route: '/pages/wishlist'
        },
        {
          displayName: 'Compare',
          iconName: 'speaker_notes',
          route: '/pages/compare',
        },
        {
          displayName: 'Checkout',
          iconName: 'feedback',
          route: '/pages/checkout'
        },
        {
          displayName: 'Cart',
          iconName: 'group',
          route: '/pages/cart'
        },
        {
          displayName: 'My Account',
          iconName: 'speaker_notes',
          route: '/pages/my-account',
        },
        {
          displayName: '404',
          iconName: 'feedback',
          route: '/pages/error'
        }
      ]
    },
    {
      displayName: 'Contact',
          iconName: 'feedback',
          route: '/pages/contact'
    }
  ];



  filteredOptions: Observable<Product[]>;

  selectedProduct = '';

  helpcontact = '';
  helptext = '';

  searchTerm : FormControl = new FormControl();


  searchResults: any[]=[];

  searchTermRunning = false;

  searchTermRunningCompt = 0;
  searchTermRunningunCompt = 0;
  placeholder = 'Rechercher une ressource';


  // tslint:disable-next-line:max-line-length
  constructor(private cartService: CartService, public productService: ProductService, public router: Router,  private sharedMethods: SharedMethods) {
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);

    this.sharedMethods.getSettings().subscribe(setting => {
      this.helpcontact = setting.helpcontact;
      this.helptext = setting.helptext;
    });

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.helpcontact = this.sharedMethods.cacheSettings.helpcontact;
        this.helptext = this.sharedMethods.cacheSettings.helptext;
      });

    } else {

      this.helpcontact = this.sharedMethods.cacheSettings.helpcontact;
      this.helptext = this.sharedMethods.cacheSettings.helptext;

    }

  }

  private _filter(value: string): Product[] {
    const filterValue = value.toLowerCase();

    const result = this.productService.cacheProduct.filter(option => {
      // on recherche dans le nom, la description et la catégorie du produit
      // tslint:disable-next-line:max-line-length
      return option.name.toLowerCase().includes(filterValue) || (option.description !== null && option.description.replace( /(<([^>]+)>)/ig, '').includes(filterValue)) || (option.category !== null && option.category.displayName.toLowerCase().includes(filterValue));
    });

    return result.slice(0,10);

  }

  ngOnInit() {

    /* this.filteredOptions = this.myControl.valueChanges
    .pipe(
      startWith(''), map(value => this._filter(value))
    ); */

    this.currency = this.currencies[0];
    this.flag = this.flags[0];
    // this.inputSideNav.open();

    if(this.productService.cacheProduct.length === 0) {


      this.productService.getProducts().subscribe((product: Product[]) => {

         this.productService.cacheProduct = product;
         // this.products = product;

      });

    }

    this.filteredOptions = this.searchTerm.valueChanges
    .pipe(
      startWith(''), map(value =>
        this._filter(value)
      )
    )

    this.searchTerm.valueChanges.subscribe(

      (term: string) => {

        // console.log(term);

        // pour se rassurer que l'évènement n'est pas declenché par la selection dans la liste des resultats
        let index = -1;

        if(this.searchResults.length !== 0)
        index = this.searchResults.findIndex(item => item.titre === term);

        if(index === -1 && term !== undefined && term !== '' && term.length >= 3) {
          this.searchTermRunning = true;
          this.searchTermRunningCompt++;
          this.placeholder = 'Recherche ressource en cours...';
          this.productService.search('true', 'true', 10, 1, term).subscribe(
            data => {
              
              this.searchTermRunningunCompt--;
              if(this.searchTermRunningCompt + this.searchTermRunningunCompt === 0) {
                this.searchTermRunning = false;
                this.searchResults = data.result;
              }
          })
        }

    });

  }

  public changeCurrency(currency){
    this.currency = currency;
  }
  public changeLang(flag){
    this.flag = flag;
  }

  updateMySelection(event) {

    // console.log(event.option.value);
    const index = this.productService.cacheProduct.findIndex(item => item.id.toString() === event.option.value);

    if( index > -1 ) {
      const prod = this.productService.cacheProduct[index];
      this.router.navigate(['/home/product', prod.id, prod.slug], { queryParams: { linkvideo: this.getIdVideo(prod) } });
      // this.selectedProduct = prod.name;
      this.selectedProduct = '';
    }

  }

  getIdVideo(product) {
    if ( product.linkvideo !== null && product.linkvideo !== undefined ) {
      const tabDate = product.linkvideo.split('/');
      const tab = tabDate[3].split('?');
      return tab[0];
    } else {

      return '';

    }
  }


  search() {
    // alert(this.selectedProduct);
    // this.filteredOptions = null;
    this.router.navigate(['/home/products/all'], { queryParams: { q: this.selectedProduct } });
  }




}
